<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>低温商品预定列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="getOrderList"></el-button>
          </el-input>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="订单编号" prop="order_id" width="150px"></el-table-column>
        <el-table-column label="下单经销商" prop="agencyName" width="130px"></el-table-column>
        <el-table-column label="价格" prop="attr_price" align="center" width="60px"> </el-table-column>
        <el-table-column label="状态" prop="status" width="140px">
          <!-- 自定义表头 -->
          <template slot="header" slot-scope="scope">
            <el-select v-model="queryInfo.status" placeholder="请选择" @change="filterSelect">
              <el-option v-for="item in statusOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
            </el-select>
          </template>
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag class="daiqueren" v-if="scope.row.status == '0'">待确认</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.status == '1'">已确认</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.status == '2'">已拒绝</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="预约类型" prop="good_type" width="120px">
          <template slot="header" slot-scope="scope">
            <el-select v-model="queryInfo.type" placeholder="请选择" @change="filterSelect">
              <el-option v-for="item in typeOptions" :key="item.id" :label="item.value" :value="item.id"> </el-option>
            </el-select>
          </template>

          <template slot-scope="scope">
            <el-tag type="" v-if="scope.row.week == '0'">下周</el-tag>
            <el-tag type="info" v-if="scope.row.week == '1'">下下周</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="商品信息" prop="is_send">
          <template slot-scope="scope">
            <!-- <template v-for="item in scope.row.goods_info"> -->
            <div>{{ scope.row.title }} /规格：{{ scope.row.attr_num }}/ 数量：{{ scope.row.buyNum }}件</div>
            <!-- </template> -->
          </template>
        </el-table-column>
        <el-table-column label="下单时间" prop="create_at" width="130px">
          <template slot-scope="scope">
            {{ scope.row.create_at }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope" v-if="scope.row.status == 0">
            <el-tooltip effect="dark" content="确认商品预定" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-success" size="mini" @click="sureById(scope.row)"></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="取消商品预定" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="refuseById(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-row>
        <!-- <el-button type="primary" plain @click="sureOrder">批量订单确认</el-button>
        <el-button type="info" plain @click="sendOrder">批量订单发货</el-button>
        <el-button type="success" plain @click="completeOrder">批量完成订单</el-button>
        <el-button type="danger" plain @click="cancelOrder">批量取消订单</el-button> -->
      </el-row>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      queryInfo: {
        query: '',
        status: -1,
        type: -1,
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待确认', id: 0 },
        { value: '已确认', id: 1 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: -1 },
        { value: '下周', id: 0 },
        { value: '下下周', id: 1 },
      ],
      total: 0,
      orderlist: [],

      multipleSelection: [],
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {

    //  exportExcel () {
    //      /* out-table关联导出的dom节点  */
    //      var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
    //      /* get binary string as output */
    //      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    //      try {
    //          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '药品信息.xlsx')
    //      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
    //      return wbout
    //  },
    // 导出Excel点击方法
    exportExcel () {
      // this.downloadLoading = true // 加载遮罩层开启
      const { export_json_to_excel } = require('../../js/Export2Excel'); //引入文件
      // const multiHeader = [['牛奶', '果汁', '食品数量', '', '零食数量', '', '', '蔬菜数量', '', '']] //对应表格输出的title
      const tHeader = ['订单号', '经销商',] //对应表格输出的title
      const filterVal = ['order_id', 'agencyName'] // 对应表格tableData输出的数据

      const list = this.orderlist
      const data = this.formatJson(filterVal, list)
      export_json_to_excel(tHeader, data, this.getNowTime() + '导出订单');
      // this.downloadLoading = false // 加载遮罩层结束
    },
    // 获取当前时间
    getNowTime: function () {
      let dateTime
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
        :
        new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
        :
        new Date().getSeconds()
      dateTime = yy + '年' + mm + '月' + dd + '日 ' + hh + '时' + mf + '分' + ss + '秒'
      console.log(dateTime)
      return dateTime
    },

    // 将JSON转换成map
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    //同意商品
    async sureById (param) {
      const confirmResult = await this.$confirm(
        '确认该商品后将不可拒绝，将扣除用户冻结余额相关额度,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      var params = {
        g_id: param.id,
        order_id: param.order_id,
        money: param.g_money,
        g_attrid: param.g_attrid,
      };
      console.log(params);
      const { data: res } = await this.$http.post('admin/order/agreenDwOrderGood', params
      )
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getOrderList();
    },

    //拒绝该商品订单
    async refuseById (param) {
      const confirmResult = await this.$confirm(
        '拒绝该商品后将不可再确认，款项将退至账户余额,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      var params = {
        g_id: param.id,
        order_id: param.order_id,
        money: param.g_money,
        g_attrid: param.g_attrid,
      };
      const { data: res } = await this.$http.post('admin/order/refuseDwOrderGood', params)
      if (res.code !== 200) {
        return this.$message.error('操作失败！')
      }
      this.$message.success('操作成功！')
      this.getOrderList();
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },


    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },
    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    // 批量确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将确认所有已选中的待确认订单，其余订单确认无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
      this.getOrderList()
    },

    // 批量发货订单
    async sendOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },
    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将所有已选中的已发货订单，其余订单完成无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    // 批量取消订单
    async cancelOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '只能取消待支付和待确认的订单，其余订单取消无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 6,
      })
      if (res.code !== 200) {
        return this.$message.error('订单取消操作失败！')
      }
      this.$message.success('订单取消操作成功！')
      this.getOrderList()
    },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/order/getDwGoodsList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
    },


    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },
    // 展示修改地址的对话框
    showBox () {
      this.addressVisible = true
    },
    addressDialogClosed () {
      this.$refs.addressFormRef.resetFields()
    },

    async showProgressBox () {
      const { data: res } = await this.$http.get('/kuaidi/804909574412544580')

      if (res.meta.status !== 200) {
        return this.$message.error('获取物流进度失败！')
      }

      this.progressInfo = res.data

      this.progressVisible = true
      console.log(this.progressInfo)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../plugins/timeline/timeline.css';
@import '../../plugins/timeline-item/timeline-item.css';

.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 30px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}
</style>
